module.exports = __webpack_public_path__ + "media/images/top/feature/top-features-5-275908f53ad07712a9fc7f547804b768.png";